import React, { useEffect } from 'react';
import Modal from 'react-modal';
import styled from 'styled-components';
import DeliveryController from '../../controller/DeliveryController';
import 'react-responsive-modal/styles.css';
import '../../styles/CustomModal.css';
import toast from 'react-hot-toast';
import { DELIVERY_POINTS } from '../../utils/DataType';
import { orderType } from './DeliveryConfirmList';
import OrderController from '../../controller/OrderController';

type Props = {
  isVisible: boolean;
  setVisible: (bVisible: boolean) => void;
  orderDetail: orderType | undefined;
  getHotelOrderNotCom: any;
};

const DeliveryConfirmModal = ({
  isVisible,
  setVisible,
  orderDetail,
  getHotelOrderNotCom,
}: Props) => {
  const onCloseModal = () => {
    setVisible(false);
  };

  const setDeliveryComplete = async () => {
    if (orderDetail) {
      const oRes = await OrderController.completePickupZone({
        order_id: orderDetail.order_id,
        order_seq: orderDetail.order_seq,
      });
      if (oRes === true) {
        window.location.reload();
      }
      getHotelOrderNotCom();
    }

    onCloseModal();
  };

  useEffect(() => {}, []);

  return (
    <Modal
      isOpen={isVisible}
      onRequestClose={onCloseModal}
      className="deliveryConfirmModal modal-content"
      closeTimeoutMS={100}
      ariaHideApp={false}>
      <Style>
        <div className="modal">
          <h3>배달이 완료된 후, 버튼을 눌러주시면</h3>
          <h3>고객님께 알림을 보내드려요!</h3>
          <img
            className="closeIcon"
            onClick={onCloseModal}
            src={`${process.env.PUBLIC_URL}/svg/ic_close_white.svg`}
            alt="close"
          />
          <div className="itemWrap">
            <h1>
              {orderDetail &&
                orderDetail.delivery_address_detail.slice(
                  3,
                  orderDetail.delivery_address_detail.length,
                )}
            </h1>
            <h2>{orderDetail && orderDetail.store_name}</h2>
          </div>
          <div className="footer">
            <button onClick={setDeliveryComplete}>
              <h2>배달완료</h2>
            </button>
          </div>
        </div>
      </Style>
    </Modal>
  );
};

export default DeliveryConfirmModal;

const Style = styled.div`
  .modal {
    position: relative;
    padding: 12% 10%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background: #343434;
  }

  h3 {
    font-size: 20px;
    line-height: 32px;
    color: #ffffff;
    font-weight: 500;
    white-space: line;
  }

  .itemWrap {
    border: 1px solid #555555;
    border-radius: 10px;
    padding: 20px;
    margin: 24px 0;
    h1 {
      font-size: 40px;
      line-height: 72px;
      color: #4dd2ae;
      font-weight: 600;
    }
    h2 {
      font-weight: 600;
      color: #ffffff;
    }
  }

  button {
    margin-top: 12px;
    width: 100%;
    /*height: calc(7vh - 4px);*/
    height: 60px;
    background: #4dd2ae;
    border: 1px solid #4dd2ae;
    border-radius: 5px;
    h2 {
      font-weight: 600;
      color: #ffffff;
    }
  }
`;
